import { render, staticRenderFns } from "./LessonDetailCard.vue?vue&type=template&id=5d5ba73a&scoped=true&"
import script from "./LessonDetailCard.vue?vue&type=script&lang=js&"
export * from "./LessonDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./LessonDetailCard.vue?vue&type=style&index=0&id=5d5ba73a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5ba73a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VIcon,VRow})
